<template>
  <vs-row>
    <vs-row><span><strong>Megrendelő neve:</strong></span> {{ selectedOrder.CustomerName }}
    </vs-row>
    <vs-row><span><strong>Megrendelő címe:</strong></span> {{ selectedOrder.CustomerAddress }}
    </vs-row>
    <vs-row><span><strong>Megrendelő telefonszáma:</strong></span>
      {{ selectedOrder.CustomerPhone }}
    </vs-row>
    <vs-row><span><strong>Megrendelő email címe:</strong></span>
      {{ selectedOrder.CustomerEmail }}
    </vs-row>
    <vs-row><span
       ><strong>Rendelés feladásának ideje:</strong></span>{{ selectedOrder.OrderDate }}
    </vs-row>
    <vs-row><span><strong>Átvétel ideje:</strong></span> {{ selectedOrder.ShippingDate }}
    </vs-row>
    <vs-row><span><strong>Átvétel módja:</strong></span> {{ selectedOrder.Shipping }}</vs-row>
    <vs-row><span><strong>Fizetés módja:</strong> </span>{{ selectedOrder.Payment }}</vs-row>

    <vs-row><span><strong>Hivatkozási szám:</strong></span>{{ selectedOrder.OrderRef }}</vs-row>
    <vs-row v-if="selectedOrder.TransactionId"><span><strong>Tranzakció azonosító:</strong></span>{{ selectedOrder.TransactionId }}</vs-row>
    <vs-row v-if="selectedOrder.TransactionId" :class="{success: selectedOrder.OrderStatus === 'SUCCESS', fail: selectedOrder.OrderStatus !== 'SUCCESS'}"><span><strong>Kártya azonosítás:</strong></span>{{ selectedOrder.OrderStatus }}</vs-row>
    <vs-row v-if="selectedOrder.TransactionId" :class="{success: selectedOrder.PaymentStatus === 'FINISHED', fail: selectedOrder.PaymentStatus !== 'FINISHED'}"><span><strong>Fizetés státusz:</strong></span>{{ selectedOrder.PaymentStatus }}</vs-row>
    <vs-row v-if="selectedOrder.TransactionId"><span><strong>Fizetés dátum:</strong></span>{{ selectedOrder.PaymentDate }}</vs-row>

    <vs-row><span><strong>Megjegyzés:</strong></span> {{ selectedOrder.Message }}</vs-row>
    <vs-row><span><strong>Saját megjegyzés:</strong></span> {{ selectedOrder.CustomMessage }}
    </vs-row>
    <vs-row vs-type="flex" vs-justify="center"><h5>Rendelés tételei</h5></vs-row>
    <vs-row v-for="(order, index) in selectedOrder.Items" :key="index">
      <vs-col vs-w="7">
        <strong>{{ order.Qty }}</strong> x {{ order.Name }}
        <vs-row v-if="order.Addons && order.Addons.length > 0">
          <strong>Extrák:</strong>
            <span v-for="(addon, addonIndex) in order.Addons" :key="addonIndex">{{ addon.AddonName }},</span>
        </vs-row>
      </vs-col>
      <vs-col vs-w="3" vs-justify="right" vs-align="flex-end">
        <p style="text-align: right; margin: 0;">
          {{order.Price }} HUF / db
        </p>
      </vs-col>
      <vs-col vs-w="2" vs-justify="right" vs-align="flex-end">
        <p style="text-align: right; margin: 0;">
        {{ order.Qty * order.Price }} HUF
        </p>
      </vs-col>
      <vs-divider></vs-divider>
    </vs-row>
    <vs-row v-if="selectedOrder.DeliveryFee != null && parseInt(selectedOrder.DeliveryFee) > 0">
      <vs-col vs-w="8"><strong>Szállítási díj:</strong></vs-col>
      <vs-col vs-w="4" vs-justify="right" vs-align="flex-end">
        <p style="text-align: right; margin: 0;">
          {{ selectedOrder.DeliveryFee }} HUF
        </p>
      </vs-col>

    </vs-row>
    <vs-row>
      <vs-col vs-w="8">
        <strong>Összesen:</strong>
      </vs-col>
      <vs-col vs-w="4" vs-justify="right" vs-align="flex-end">
        <p style="text-align: right; margin: 0;">
          {{ selectedOrder.Total }} HUF
        </p>
      </vs-col>
    </vs-row>
    <vs-row class="justify-content-center">
      <vs-button @click="addDesc=!addDesc" color="success" type="gradient">Megjegyzés hozzáadása</vs-button>
    </vs-row>
    <transition name="fade">
      <vs-row v-if="addDesc">
        <vs-col vs-lg="10" vs-sm="12">
          <vs-textarea label="Megjegyzés" v-model="selectedOrder.CustomMessage"/>
        </vs-col>
        <vs-col vs-lg="2" vs-sm="12">
          <vs-button @click="saveDesc()" color="success" type="gradient">Mentés</vs-button>
        </vs-col>
        <vs-row class="justify-content-center">
        </vs-row>
      </vs-row>
    </transition>
  </vs-row>
</template>
<script>

import {axiosInstance} from "@/main";

export default {
  name: "order_detail",
  props: ['selectedOrder'],
  data() {
    return {
      addDesc: false
    }
  },
  methods: {
    saveDesc() {
      let self = this;
      let payload = {};
      payload.CustomMessage = self.selectedOrder.CustomMessage;
      payload.OrderId = self.selectedOrder.OrderId;
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: `Megerősítés`,
        text: 'Valóban menti a megjegyzést?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .post('admin/updateCustomMessageController.php', payload, {
                withCredentials: true,
              })
              .then((resp) => {
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres mentés.' : 'Sikertelen mentés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
                self.addDesc = false;
                self.$parent.$emit('closemodal');
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  }
}
</script>

<style scoped>
.vs-button {
  margin-top: 15px;
  margin-bottom: 15px;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

h5 {
  margin: 15px 0;
}

span {
  width: 165px;
}
.success {
  color: #17c964;
}

.fail {
  color: #dc3545;
}

</style>